import { useState } from "react";

const imageFormats = ["jpg", "jpeg", "png", ".gif"];

export const evalPath = (src: string) => {
    if (src.indexOf("http://") === 0 || src.indexOf("https://") === 0) return src;

    const image = src.split("/").pop();
    const hasFormat = image && imageFormats.some((img) => image.indexOf(`${img}`) > -1);
    const composeOptimisedPath = hasFormat ? `${src}.img.140.medium.jpg` : src;
    return composeOptimisedPath;
};

type Props = {
    src: string;
    alt: string;
    defaultSrc: string;
    className?: string;
};

const AuthorPicture = ({ className, src, alt, defaultSrc }: Props) => {
    const [source, setSource] = useState<string>(evalPath(src));
    const onImageError = () => {
        if (defaultSrc) {
            setSource(defaultSrc);
        }
    };

    return (
        <div className={`w-[6.25rem] h-[6.25rem] self-center ${className}`}>
            <img
                className="rounded-[50%] border-[5px] solid border-[#e3e3e3]"
                src={source}
                alt={alt}
                onError={onImageError}
            />
        </div>
    );
};

export default AuthorPicture;
